// Translation: Arabic > Status
const status = Object.freeze({
	loadingData: 'جارِ تحميل البيانات',
	updatingData: 'جارِ تحديث البيانات'
})

// Export
export default status
